module.exports = __webpack_public_path__ + "img/group_img.ca005f2b.png";